export const initialState = {
  books: [],
  book: {},
};
